import getSale from '@/core/helpers/get-sale';

const OfferLabels = ({ props, parent }) => {
    const { offer, settings } = props;
    const { style: styles, showSale, include, exclude } = settings;
    const { $t } = parent;

    const labels = [];
    
    const isAvailableShowSale = showSale && offer.oldPrice;

    offer.labels?.forEach((label) => {
        const labelId = label.id;
        let isAvailablePushLabel = true;

        if (exclude?.includes(labelId)) {
            isAvailablePushLabel = false;
        } else if (include && !include?.includes(labelId)) {
            isAvailablePushLabel = false;
        }

        if (isAvailablePushLabel) {
            labels.push(label);
        }
    });

    if (!labels.length && !isAvailableShowSale) {
        return;
    }

    labels.sort((a, b) => {
        return a.title.length - b.title.length;
    });

    const labelsStyle = {
        ...styles,
    };

    for (let style in styles) {
        if (['top', 'left', 'right', 'bottom'].includes(style)) {
            labelsStyle.position = 'absolute';
            break;
        }
    }

    if (isAvailableShowSale) {
        const sale = getSale(offer.price, offer.oldPrice);

        if (sale) {
            labels.unshift({
                id: 'sale',
                title: `-${sale}%`,
            });
        }
    }

    const labelNodes = labels.map((label) => {
        const classes = [
            'l-ss-c-offer-label',
            `l-ss-c-offer-label-type-${label.id}`,
            label.id === 'available' ? 'l-ss-c-offer-label-type-available' : '',
        ];

        return <div class={classes}>{$t(`labels.${label.id}`, null, label.title)}</div>;
    });

    const labelsClasses = ['l-ss-c-offer-labels'];

    if (labelsStyle.position === 'absolute') {
        labelsClasses.push('l-ss-c-offer-labels-absolute');
    }

    return (
        labelNodes.length && <div class={labelsClasses} style={labelsStyle}>
            {labelNodes}
        </div>
    );
};

OfferLabels.props = {
    offer: {
        type: Object,
    },
    settings: {
        type: Object,
    },
};

export default OfferLabels;
